import { slugify } from '@superbet-group/web.lib.utilities';
import OfferEvent from '@core/models/offer/OfferEvent';
import router from '@app/router';
import { StatsEvent } from '@core/models/base/StatsEvent';

export function getEventSlugFromEvent(event: OfferEvent): string {
    return slugify(`${event.fullName}-${event.id}`).replace('·', '-');
}

export function getEventId(): string | undefined {
    return router.currentRoute.params.eventSlug?.split('-').pop();
}

export function getEventSlugFromStatsEvent(event: StatsEvent): string {
    return slugify(`${event.team1.name}-${event.team2.name}-${event.id}`);
}

export function getOfferEventIdFromStatsEvent(event: StatsEvent | null): any {
    return event?.offer_id?.value?.split(':').pop();
}
